import React, { useId } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actions as modulesActions } from "@/reducers/modules";
import IconGlyph from "@gc-npm/components.icon-glyph";
import ShoppingCartFooterNew from "@/components/ShoppingCart/ShoppingCartFooterNew";
import CustomLink from "@gc-npm/components.custom-link";
import TextInfo, {
  TEXT_COLOR,
  TEXT_FONT_WEIGHT,
  TEXT_KIND,
  TEXT_SIZE,
} from "@gc-npm/components.text";
import { actions as modalActions } from "@gc-npm/reducers.modals-reducer";
import CheckBox from "@/components/CheckBox";
import MobilesLinesModal from "@/components/Modals/MobilesLinesModal";
import { mobileLinesModalNavigationProps } from '@/utils/mobile-lines-modal';
import Price, {
  PRICE_FONT_WEIGHT,
  PRICE_SIZE,
} from "@gc-npm/components.price";
import {
  SCREEN_TYPES,
  SHOPPING_CART_FOOTER_LAYOUTS,
  LAYOUT_TYPES,
} from "@/utils/constants";
import { normalizeTitle } from "@/utils/index";
const COMPONENT_NAME = "OneLineSection";
const normalizeText = (text) => {
  return text
    .toLowerCase()
    .normalize("NFD") // Descompone caracteres con acentos
    .replace(/[\u0300-\u036f]/g, ""); // Elimina los diacríticos (acentos)
};
const OneLineSection = ({
  subSectionTitle,
  oneLineSectionKey,
  itemsTorender,
  screenType,
  formSkeletonProps,
}) => {
  const dispatch = useDispatch();
  const labelId = useId();
  const lme = useSelector((state) => state.modulos?.conectividad?.lme);
  const layout = useSelector((state) => state.UI.layout);
  // Nº de líneas móviles que el cliente ha añadido (suma de cantidades de las lme).
  const addedLinesCount = (lme?.items || []).reduce(
    (sum, item) => sum + (Number(item?.quantity) || 0),
    0
  );

  if (
    !itemsTorender ||
    !Array.isArray(itemsTorender) ||
    !itemsTorender.length > 0
  ) {
    return null;
  }

  const taggingInfo = {
    componentName: COMPONENT_NAME,
    componentContent: "",
    componentProduct: "",
    componentVariation: "all",
  };

  const itemToShow = itemsTorender.find(
    (eachItem) => eachItem.orderSubcategory === 1
  );
  if (!itemToShow) {
    return null;
  }
  const {
    id,
    selected,
    category,
    subcategory,
    price,
    prices,
    promoPrice,
    linkModal,
    promoDuration,
    title,
  } = itemToShow;
  const finalPromoPrice =
    prices?.installationPrices?.promoPrice || promoPrice?.price;

  const onChange = () => {
    dispatch(
      modulesActions.selectModules({
        ids: [{ id, qty: 1 }],
        category: normalizeText(category),
        subcategory: normalizeText(subcategory),
      })
    );
  };
  const isMobile = screenType === SCREEN_TYPES.MOBILE;
  const onclickMobileLinesModal = () => {
    dispatch(
      modalActions.addModal({
        id: "MobileLinesModal",
        Element2Show: MobilesLinesModal,
        modalProps: {
          closeByClickingOutside: true,
          contentPosition: isMobile ? "center--bottom" : "center--center",
          inSceneEffect: isMobile ? "fadeInBottom" : "fadeIn",
          outSceneEffect: isMobile ? "fadeOutBottom" : "fadeOut",
          opacityLayoutColor: "blur",
          scrollAllowed: false,
          taggingInfoWhenClickingOutside: {
            ...taggingInfo,
            componentName: "mobileLinesModal",
            componentContent: "cerrar",
          },
          ...mobileLinesModalNavigationProps,
        },
        elementProps: {
          screenType,
        },
      })
    );
  };
  const shoppingCartFooterProps = {
    price: prices?.contractPrices?.price,
    onClick: onChange,
    buttonText: `${selected ? "Quitar" : "Añadir"}`,
    titlePrice: "",
    isModalFicha: true,
    screenType: screenType,
    promoDuration: promoDuration,
    promoPriceAlt: promoPrice,
    finalPromoPrice: finalPromoPrice,
    quotePromo: prices?.installationPrices?.promoPrice ? "" : "mes",
  };

  return (
    <div key={oneLineSectionKey} className="OneLineSection">
      {subcategory === "lme" && (
        <CustomLink
          onClick={onclickMobileLinesModal}
          taggingInfo={{
            ...taggingInfo,
            componentProduct: "modal lineas móviles",
          }}
        >
          <div className="lmeButton">
            <span className="lmeButton__plus">+</span>
            <TextInfo
              text={`Añadir líneas móviles desde ${price?.price || 9} €/mes${
                addedLinesCount > 0 ? ` (${addedLinesCount})` : ""
              }`}
              color={TEXT_COLOR.MOVISTAR_BLUE}
              fontType={TEXT_FONT_WEIGHT.REGULAR}
              size={TEXT_SIZE.BODY2}
            />
          </div>
        </CustomLink>
      )}
      {subcategory !== "lme" && layout !== LAYOUT_TYPES.CONECTIVIDAD && (
        <>
          <div className="checkbox">
            <CheckBox
              name={subSectionTitle}
              ariaLabelledBy={labelId}
              formSkeletonProps={formSkeletonProps}
              taggingInfo={{ ...taggingInfo, componentProduct: title?.title }}
              checked={selected}
              onChange={onChange}
            />
          </div>
          <div className="lineSection">
            {linkModal?.href && (
              <CustomLink
                taggingInfo={{
                  ...taggingInfo,
                  componentProduct: title?.title,
                  componentContent: title?.title,
                }}
                {...linkModal}
                additionalContent={
                  <ShoppingCartFooterNew
                    {...shoppingCartFooterProps}
                    layoutType={
                      isMobile
                        ? SHOPPING_CART_FOOTER_LAYOUTS.MODAL_FICHA_MOBILE
                        : SHOPPING_CART_FOOTER_LAYOUTS.MODAL_FICHA_DESKTOP
                    }
                  />
                }
              >
                <div id={labelId} className="lineSectionText">
                  <TextInfo
                    {...title}
                    text={normalizeTitle(title?.text)}
                    color={TEXT_COLOR.MOVISTAR_BLUE}
                    fontType={TEXT_FONT_WEIGHT.REGULAR}
                    size={TEXT_SIZE.BODY2}
                  />
                </div>
              </CustomLink>
            )}
            {!linkModal?.href && (
              <div id={labelId} className="lineSectionText">
                <TextInfo
                  {...title}
                  text={`${title?.text} por <strong>${price?.price} €/mes</strong>`}
                  color={TEXT_COLOR.GREY6}
                  kind={TEXT_KIND.SPAN}
                  fontType={TEXT_FONT_WEIGHT.REGULAR}
                  size={TEXT_SIZE.BODY2}
                />
              </div>
            )}
          </div>
        </>
      )}
      <style jsx>
        {`
          .OneLineSection {
            display: flex;
            flex-direction: row;
            align-items: center;
            gap: 0.5rem;
            .lmeButton {
              display: flex;
              flex-direction: row;
              align-items: center;
              gap: 0.4rem;
              padding: 0.4rem 1rem;
              border: 1.5px dashed #0066ff;
              border-radius: 2rem;
              cursor: pointer;
              &__plus {
                color: #0066ff;
                font-size: 1rem;
                line-height: 1;
                font-weight: 400;
              }
            }
            .checkbox {
              max-width: 20px;
              max-height: 20px;
              min-width: 20px;
            }
            :global(.CheckBox) {
              max-width: 20px;
              max-height: 20px;
            }
            .lineSection {
              display: flex;
              flex-direction: row;
              gap: 0.2rem;
              align-items: center;
              flex-wrap: wrap;
            }
            .lineSectionText {
              display: flex;
              flex-direction: row;
              gap: 0.2rem;
              align-items: center;
              flex-wrap: wrap;
            }
          }
          @media screen and (max-width: 768px) {
            .OneLineSection {
              align-items: flex-start;
              .checkbox {
                padding-top: 4px;
              }
              .lineSection {
                flex-direction: column;
                align-items: flex-start;
                gap: 0;
              }
              .lineSectionText {
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
                flex-wrap: nowrap;
              }
              .modulos {
                gap: 0.5rem;
                justify-content: space-between;
              }
            }
          }
        `}
      </style>
    </div>
  );
};

export default OneLineSection;
